module.exports = __webpack_public_path__ + "img/powered_by_horizontal_c.9a5042b6.png";